var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgReuseContent = function SvgReuseContent(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 15 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.02 8.262a.52.52 0 0 1 .522.52v1.042h1.041a.52.52 0 0 1 0 1.042H8.021a.52.52 0 0 1-.521-.52V8.782a.52.52 0 0 1 .52-.521ZM11.668 11.384a.52.52 0 0 1 .52-.52h1.563a.52.52 0 0 1 .521.52v1.563a.52.52 0 1 1-1.042 0v-1.042H12.19a.52.52 0 0 1-.521-.52Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.09 8.113a2.865 2.865 0 0 1 3.497 1.796.52.52 0 0 1-.982.348 1.824 1.824 0 0 0-3.02-.67l-1.208 1.136a.52.52 0 1 1-.713-.76l1.203-1.13c.34-.339.762-.587 1.224-.72Zm4.04 2.915c.196.21.186.54-.023.736l-1.203 1.13a2.864 2.864 0 0 1-4.72-1.075.52.52 0 0 1 .981-.348 1.823 1.823 0 0 0 3.02.67l1.208-1.136a.521.521 0 0 1 .737.023Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.625 4.875C.625 3.839 1.465 3 2.5 3h8.125c1.036 0 1.875.84 1.875 1.875V6.75a.625.625 0 1 1-1.25 0V4.875a.625.625 0 0 0-.625-.625H2.5a.625.625 0 0 0-.625.625v6.25c0 .345.28.625.625.625h4.375a.625.625 0 1 1 0 1.25H2.5a1.875 1.875 0 0 1-1.875-1.875v-6.25Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.75 6.75c0-.345.28-.625.625-.625H8.75a.625.625 0 1 1 0 1.25H4.375a.625.625 0 0 1-.625-.625ZM3.75 9.25c0-.345.28-.625.625-.625H6.25a.625.625 0 1 1 0 1.25H4.375a.625.625 0 0 1-.625-.625Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReuseContent);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;